<template lang="pug">
	.creative-dashboard
		TutorialArrow
		Dashboard
		VueNotification(group="notifications-wrapper" position="bottom right")
</template>

<script>
	import TutorialArrow from './components/Tutorial/TutorialArrow'
	import Dashboard from './components/Dashboard/Dashboard'

	export default {
		name: 'app',
		components: {
			TutorialArrow,
			Dashboard
		},
		data() {
			return {

			}
		},
		created() {

		}
	}
</script>

<style lang="sass">
	// CoreUI Icons Set
	@import '~@coreui/icons/css/coreui-icons.min.css'
	/* Import Font Awesome Icons Set (шрифт пересобран с исправленными bbox глифов) */
	@import 'assets/scss/font-awesome'
	/* Import Simple Line Icons Set */
	$simple-line-font-path: '~simple-line-icons/fonts/'
	@import '~simple-line-icons/scss/simple-line-icons.scss'
	/* Import Flag Icons Set */
	@import '~flag-icon-css/css/flag-icon.min.css'
	/* Import Bootstrap Vue Styles */
	@import '~bootstrap-vue/dist/bootstrap-vue.css'
	// Import Main styles for this application
	@import 'assets/scss/style'

	*
		margin: 0
		padding: 0

	body
		background-color: #2f353a
		width: 100%
		height: 100%
		position: fixed
		top: 0
		left: 0
		overflow: hidden

	fieldset
		border: none

	.tooltip
		pointer-events: none
		z-index: 5000 !important

</style>
